import React from "react";
//#region types
import { TodoCardProps } from "models/propTypes/todoPropTypes";
import { TranslationKeys } from "translations";
import { WintSuperkollAPIModel as ApiModels } from "wint-api-client/dist/types";
import { CurrencyEnums } from "models/enums";
import { FormHandles } from "models/propTypes/genericFormProps";
import { StoppedPaymentsService } from "services";
//endregion
//#region components
import TopTodoCard from "../../_partials/topTodoCard";
import { StoppedPaymentsFooter, StoppedPaymentsList, StoppedPaymentsTodoSelection } from "components/payment";
import { EntityCardContent } from "components/common";
import { useStoppedPaymentsService } from "serviceHooks";
//#endregion
//#region services
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const StoppedPaymentsTodo: React.FC<TodoCardProps> = (props) => {
  const stoppedPaymentsService = useStoppedPaymentsService();
  const formRef = React.useRef<FormHandles>(null);
  const { stoppedPayments } = props.item;

  const [selectedPaymentsCount, setTotalPaymentsCount] = React.useState<number>(0);
  const [selectedPaymentsTotalAmount, setTotalAmount] = React.useState<number>(0);
  const [selectedPayments, setSelectedPayments] = React.useState<ApiModels.StoppedPayment[]>([]);
  const [loading, setLoading] = React.useState(false);

  const onSelectedPaymentsChange = (payments: ApiModels.StoppedPayment[]) => {
    setSelectedPayments(payments);
  };

  const reschedulePayments = (submitFunc?: (values: any) => Promise<any>) => {
    return (formRef.current && formRef.current.submit(submitFunc)) || new Promise<void>((resolve) => resolve());
  };

  React.useEffect(() => {
    setTotalPaymentsCount(selectedPayments.length);
    setTotalAmount(selectedPayments ? stoppedPaymentsService.getTotalSelectedPaymentsAmount(selectedPayments) : 0);
  }, [selectedPayments]);

  const reloadTodo = (onSuccess?: (item: ApiModels.StoppedPayments) => void) => {
    setSelectedPayments([]);
    setLoading(true);
    stoppedPaymentsService
      .getStoppedPayments()
      .then((result) => {
        onSuccess && onSuccess(result);
        props.onActionSuccess();
      })
      .finally(() => setLoading(false));
  };

  return (
    <EntityCardContent
      topTodoCard={
        <TopTodoCard
          item={props.item}
          descriptionHeadingOne={`${LocalizationHelperInstance.getFormattedCurrency(stoppedPayments?.amount ?? 0)} ${
            CurrencyEnums.CurrencyCode.SEK
          }`}
          descriptionHeadingTwo={`${stoppedPayments?.total} ${LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.Common.Pc
          )}`}
          footerText={
            stoppedPayments?.date !== undefined
              ? `${LocalizationHelperInstance.getFormattedMessage(
                  TranslationKeys.Common.Due_Date
                )}: ${LocalizationHelperInstance.getFormattedDate(StoppedPaymentsService.getDueDate(stoppedPayments))}
              `
              : ""
          }
        />
      }
      todoMainSection={
        <StoppedPaymentsTodoSelection
          ref={formRef}
          selectedPaymentsCount={selectedPaymentsCount}
          selectedPaymentsTotal={selectedPaymentsTotalAmount}
        />
      }
      footer={
        <StoppedPaymentsFooter
          selectedPayments={selectedPayments}
          rescheduleFormSubmitHandler={reschedulePayments}
          reloadHandler={reloadTodo}
          disableSuccessMessages
        />
      }
      infoViewer={
        <StoppedPaymentsList
          items={stoppedPayments!.stoppedPaymentList}
          onRowSelectionsChange={onSelectedPaymentsChange}
          selectedPayments={selectedPayments}
          reloadHandler={reloadTodo}
        />
      }
      loading={loading}
    ></EntityCardContent>
  );
};

export default StoppedPaymentsTodo;
